type CatalogType = {
  clientId?: number
}

const settings: CatalogType = {}

try {
  Object.assign(settings, JSON.parse(process.env.REACT_APP_ILCATS || '[]'))
} catch (error) {}

export default settings
